import { render, staticRenderFns } from "./studentEdit.vue?vue&type=template&id=313b3c2e&"
import script from "./studentEdit.vue?vue&type=script&lang=ts&"
export * from "./studentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports